import { Route } from '@/core/entities/types/routes';
import { INITIAL_ROUTE } from '@/core/entities/types/routes.const';
import { loaderOldRoutes, protectedLoader } from '@/core/middleware/loaders';
import Application from '@/core/pages/application/application';

import { redirect } from '@/core/utils/routes.utils';

import attendanceRoutes from '@/modules/attendance/routes';
import auditRoute from '@/modules/audit/routes';
import { Routes as AuthRoutes } from '@/modules/authentication';
import AuthContainer from '@/modules/authentication/pages/authContainer/authContainer';
import { beneficiariesByCompanyRoutes, allBeneficiariesRoutes } from '@/modules/beneficiary/routes';
import cadastralDataMatchingRoutes from '@/modules/cadastralDataMatching/routes';
import cadastralPositionRoutes from '@/modules/cadastralPosition/routes/routes';
import companyRoute from '@/modules/company/routes';
import companyGroupsRoutes from '@/modules/companyGroup/routes/routes';
import copayRoutes from '@/modules/copay/routes/routes';
import contractRoutes from '@/modules/contract/routes';
import filesRoute from '@/modules/files/routes';
import healthManageRoutes from '@/modules/healthManage/routes/routes';
import usersRoute from '@/modules/user/routes';
import customizationRoute from '@/modules/customization/routes/routes';
import NotFound from '../views/notFound/notFound';

/**
 * Definition of routes, which require permission checks to determine if a user has access.
 */

const Routes: Route[] = [
  ...AuthRoutes,
  /**
   *
   * Remover estas rotas antigas assim que as comunicações enviadas pelo portal forem normalizadas.
   */
  {
    path: '/confirm-email',
    Component: AuthContainer,
    loader: loaderOldRoutes,
  },
  {
    path: '/login',
    Component: AuthContainer,
    loader: loaderOldRoutes,
  },
  {
    path: '/reset-password',
    Component: AuthContainer,
    loader: loaderOldRoutes,
  },
  {
    path: '/totp',
    Component: AuthContainer,
    loader: loaderOldRoutes,
  },
  {
    path: '/',
    Component: Application,
    loader: protectedLoader,
    children: [
      {
        index: true,
        loader: () => {
          return redirect(INITIAL_ROUTE);
        },
      },
      {
        path: '/company',
        loader: () => {
          return redirect(INITIAL_ROUTE);
        },
      },

      // Empresas
      ...companyRoute,
      ...contractRoutes,
      ...filesRoute,
      ...beneficiariesByCompanyRoutes,
      ...attendanceRoutes,
      ...cadastralDataMatchingRoutes,
      ...customizationRoute,

      // Corretoras
      ...copayRoutes,
      ...allBeneficiariesRoutes,
      ...companyGroupsRoutes,
      ...cadastralPositionRoutes,
      ...auditRoute,
      ...healthManageRoutes,
      ...usersRoute,
      {
        path: '*',
        Component: NotFound,
      },
    ],
  },
];

export { Routes };
